"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.img = exports.channelRoot = void 0;

var _util = require("../../../../util");

const channelRoot = ({
  theme
}) => ({
  border: "2px solid ".concat((0, _util.color)(theme, 'disabled.3')),
  borderRadius: '50%',
  height: '34px',
  width: '34px',
  background: 'white',
  userSelect: 'none'
});

exports.channelRoot = channelRoot;

const img = () => ({
  maxWidth: '100%'
});

exports.img = img;
//# sourceMappingURL=Channel.style.js.map